// src/utils/api.js

/**
 * Vercel Serverless Function을 통해 편지 생성
 * API 키는 서버 환경변수에서 안전하게 처리됩니다.
 */
export const generateLetter = async (system, prompt) => {
  const response = await fetch("/api/generate", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ system, prompt }),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || `API 오류: ${response.status}`);
  }

  const data = await response.json();
  if (!data.text) throw new Error("편지를 생성하지 못했어요.");
  return data.text;
};
